module.exports = __webpack_public_path__ + "img/把握流行，精准选款.96bf3cd8.png";